import { useFormik } from "formik";

interface reportParam {
  initialValues: {
    [key: string]: any;
  };
  enableReinitialize?: boolean;
  onSubmitFn: (values: { [key: string]: any }) => any;
  validate: (values: any) => any;
}

const FormikInputRequest = ({
  initialValues,
  // enableReinitialize = true,
  onSubmitFn,
  validate,
}: reportParam) =>
  useFormik({
    initialValues,
    // enableReinitialize,
    onSubmit: onSubmitFn,
    validate: validate,
  });
export const FormikInputRequestCustom = ({
  initialValues,
  enableReinitialize = true,
  onSubmitFn,
  validate,
}: reportParam) =>
  useFormik({
    initialValues,
    enableReinitialize,
    onSubmit: onSubmitFn,
    validate: validate,
  });
export default FormikInputRequest;
